/* Original CEIKA year-first picker. Uses the owned vehicle taxonomy, without third-party UI code. */
(() => {
  'use strict';
  window.CeikaVehiclePicker = {mount};
  function mount(hub, {request, onSelect, onModeChange}) {
    const copy = JSON.parse(hub.querySelector('[data-garage-copy]')?.textContent || '{}');
    const text = (key, fallback) => copy[key] || fallback;
    const names=['year','make','model','variant'], fields={}, values={}, cache=new Map();
    const form=hub.querySelector('[data-guided-vehicle-search]'), quick=hub.querySelector('[data-vehicle-search]');
    const submit=hub.querySelector('[data-picker-submit]'), status=hub.querySelector('[data-search-status]');
    let mode='guided', pendingVehicle=null, resolving=null, revision=0;
    const normalize=value=>String(value).normalize('NFKD').toLowerCase().replace(/[\u0300-\u036f]/g,'').trim();
    names.forEach(name=>{fields[name]={box:hub.querySelector(`[data-picker-field="${name}"]`),input:hub.querySelector(`[data-picker-input="${name}"]`),toggle:hub.querySelector(`[data-picker-toggle="${name}"]`),list:hub.querySelector(`[data-picker-options="${name}"]`),options:[],visible:[],active:-1,controller:null,loadedKey:null};values[name]=null;});
    function close(name){const f=fields[name];f.list.hidden=true;f.input.setAttribute('aria-expanded','false');f.input.removeAttribute('aria-activedescendant');f.active=-1;}
    function closeAll(){names.forEach(close);}
    function enable(name,enabled){fields[name].input.disabled=!enabled;fields[name].toggle.disabled=!enabled;}
    function resetAfter(name){
      resolving?.abort();revision++;pendingVehicle=null;submit.disabled=true;
      names.slice(names.indexOf(name)+1).forEach(next=>{
        const f=fields[next];f.controller?.abort();f.input.value='';f.options=[];f.loadedKey=null;values[next]=null;delete f.box.dataset.selected;enable(next,false);close(next);
      });
      if(name!=='variant')fields.variant.box.hidden=true;
    }
    function parameters(name){
      const params={level:{year:'years',make:'makes',model:'models',variant:'vehicles'}[name],limit:100};
      if(name!=='year'&&values.year)params.year=values.year.value;
      if(['model','variant'].includes(name)&&values.make)params.make=values.make.value;
      if(name==='variant'&&values.model)params.model=values.model.value;
      return params;
    }
    async function fetchAll(params,signal){
      const key=JSON.stringify(params);if(cache.has(key))return cache.get(key);
      let cursor=null,items=[];
      for(let page=0;page<10;page++){
        const response=await request('/api/v1/vehicles',{...params,...(cursor?{cursor}:{})},signal);
        if(!Array.isArray(response.items))throw new Error('invalid_response');
        items.push(...response.items);if(!response.nextCursor){if(cache.size>60)cache.clear();cache.set(key,items);return items;}cursor=response.nextCursor;
      }
      throw new Error('too_many_options');
    }
    function optionsFor(name,items){
      return items.map(item=>{
        const value=name==='variant'?item.id:item[name];
        const label=name==='variant'?(item.label||item.variant||item.model):String(value??'');
        const aliases=name==='model'&&Array.isArray(item.searchAliases)?item.searchAliases.filter(alias=>typeof alias==='string'):[];
        return {value,label,item,hint:aliases.join(' · '),searchText:[label,...aliases].join(' ')};
      }).filter(option=>option.value!==null&&option.value!==undefined&&option.label);
    }
    function setActive(name,index){
      const f=fields[name];f.active=index;
      [...f.list.querySelectorAll('[role="option"]')].forEach((el,i)=>el.dataset.active=String(i===index));
      const option=f.list.querySelectorAll('[role="option"]')[index];
      if(option){f.input.setAttribute('aria-activedescendant',option.id);option.scrollIntoView({block:'nearest'});}else f.input.removeAttribute('aria-activedescendant');
    }
    function render(name){
      const f=fields[name];if(f.input.disabled)return;
      const query=values[name]?.label===f.input.value?'':normalize(f.input.value);
      f.visible=f.options.filter(option=>normalize(option.searchText).includes(query));f.list.replaceChildren();f.active=-1;f.input.removeAttribute('aria-activedescendant');
      f.visible.forEach((option,index)=>{
        const li=document.createElement('li');li.id=`${f.list.id}-${index}`;li.setAttribute('role','option');li.setAttribute('aria-selected',String(values[name]?.value===option.value));li.textContent=option.label;
        if(option.hint){const hint=document.createElement('small');hint.textContent=option.hint;li.append(hint);}
        li.addEventListener('pointerdown',event=>event.preventDefault());li.addEventListener('click',()=>select(name,option));f.list.append(li);
      });
      if(!f.visible.length){const empty=document.createElement('li');empty.className='cvp-empty';empty.setAttribute('role','presentation');empty.textContent=text('no_matches', 'No matches. Try model/chassis search.');f.list.append(empty);status.textContent=text('no_matches', 'No matches. Try model/chassis search.');}
      f.list.hidden=false;f.input.setAttribute('aria-expanded','true');
    }
    async function open(name){
      const f=fields[name];if(f.input.disabled)return;
      names.filter(x=>x!==name).forEach(close);
      if(name==='variant'){render(name);return;}
      const params=parameters(name),key=JSON.stringify(params);
      if(f.loadedKey===key){render(name);return;}
      f.controller?.abort();const controller=new AbortController();f.controller=controller;f.input.setAttribute('aria-busy','true');
      status.textContent=text('loading_choices', 'Loading vehicle choices…');
      try{
        const items=await fetchAll(params,controller.signal);
        if(controller.signal.aborted||f.controller!==controller)return;
        f.options=optionsFor(name,items);f.loadedKey=key;status.textContent='';
        if(mode==='guided'&&document.activeElement===f.input)render(name);
      }catch(error){if(!controller.signal.aborted)status.textContent=text('choices_unavailable', 'Vehicle choices are temporarily unavailable. Try model/chassis search, or browse all products.');}
      finally{if(f.controller===controller)f.input.removeAttribute('aria-busy');}
    }
    async function resolveVehicle(advance){
      const current=++revision;resolving?.abort();const controller=new AbortController();resolving=controller;submit.disabled=true;
      status.textContent=text('checking_versions', 'Checking vehicle versions…');
      try{
        const items=await fetchAll(parameters('variant'),controller.signal);
        if(controller.signal.aborted||current!==revision)return;
        const options=optionsFor('variant',items);fields.variant.options=options;
        if(options.length===1){pendingVehicle=options[0].item;fields.variant.box.hidden=true;submit.disabled=false;status.textContent=text('ready', 'Ready. Show your product options below.');if(advance)submit.focus();}
        else if(options.length>1){fields.variant.box.hidden=false;enable('variant',true);status.textContent=text('choose_version', 'Choose the matching version or chassis before continuing.');if(advance){fields.variant.input.focus();render('variant');}}
        else{status.textContent=text('no_application', 'No listed application for this combination. Search by model/chassis or ask us about your car.');}
      }catch(error){if(!controller.signal.aborted)status.textContent=text('versions_error', 'We could not check the vehicle versions. Try again or use model/chassis search.');}
    }
    function select(name,option,{advance=true}={}){
      resetAfter(name);values[name]=option;fields[name].input.value=option.label;fields[name].box.dataset.selected='true';close(name);status.textContent='';
      if(name==='year'||name==='make'){
        const next=names[names.indexOf(name)+1];enable(next,true);
        if(advance)fields[next].input.focus();
      }else if(name==='model'){resolveVehicle(advance);}
      else{pendingVehicle=option.item;submit.disabled=false;status.textContent=text('ready', 'Ready. Show your product options below.');if(advance)submit.focus();}
    }
    function switchMode(next,{focus=true}={}){
      mode=next;closeAll();onModeChange?.(next);form.hidden=next!=='guided';quick.hidden=next!=='search';hub.querySelector('[data-guided-help]').hidden=next!=='guided';
      hub.querySelectorAll('[data-picker-mode]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.pickerMode===next)));status.textContent='';
      if(focus){if(next==='search')quick.querySelector('input').focus();else fields.year.input.focus();}
    }
    names.forEach(name=>{
      const f=fields[name];
      f.input.addEventListener('focus',()=>open(name));
      f.toggle.addEventListener('click',()=>{if(f.list.hidden){if(document.activeElement===f.input)open(name);else f.input.focus();}else close(name);});
      f.input.addEventListener('input',()=>{values[name]=null;delete f.box.dataset.selected;resetAfter(name);open(name);});
      f.input.addEventListener('keydown',event=>{
        if(event.key==='Escape'){event.preventDefault();close(name);return;}
        if(['ArrowDown','ArrowUp'].includes(event.key)){
          event.preventDefault();if(f.list.hidden){open(name).then(()=>{if(!f.list.hidden)setActive(name,event.key==='ArrowDown'?0:f.visible.length-1);});}
          else if(f.visible.length)setActive(name,Math.max(0,Math.min(f.visible.length-1,f.active+(event.key==='ArrowDown'?1:-1))));
        }else if(!f.list.hidden&&['Home','End'].includes(event.key)){event.preventDefault();setActive(name,event.key==='Home'?0:f.visible.length-1);}
        else if(event.key==='Enter'&&!f.list.hidden){event.preventDefault();const exact=f.visible.find(o=>normalize(o.label)===normalize(f.input.value));const option=f.visible[f.active]||exact||(f.visible.length===1?f.visible[0]:null);if(option)select(name,option);}
        else if(event.key==='Tab'){
          const exact=f.visible.find(o=>normalize(o.label)===normalize(f.input.value));if(!values[name]&&exact)select(name,exact,{advance:false});close(name);
        }
      });
      f.box.addEventListener('focusout',event=>{if(!f.box.contains(event.relatedTarget))close(name);});
    });
    hub.querySelectorAll('[data-picker-mode]').forEach(button=>button.addEventListener('click',()=>switchMode(button.dataset.pickerMode)));
    hub.querySelector('[data-year-unknown]').addEventListener('click',()=>{
      const input=quick.querySelector('input');if(!input.value)input.value=[values.make?.label,values.model?.label].filter(Boolean).join(' ');switchMode('search');
    });
    document.addEventListener('pointerdown',event=>{if(!event.target.closest('[data-picker-field]'))closeAll();});
    form.addEventListener('submit',event=>{
      event.preventDefault();if(!pendingVehicle||!values.year||!values.make||!values.model)return;
      const year=Number(values.year.value),variant=pendingVehicle.variant||'';
      const label=`${year} ${values.make.label} ${values.model.label}${variant?' '+variant:''}`;
      closeAll();onSelect({...pendingVehicle,year,label});
    });
    return {focus(){switchMode('guided');},showSearch(){switchMode('search');},close:closeAll};
  }
})();
